import { BiGetUserInfo, GetBiMenu } from '@/app/bi_admin/login/apis';
import { useRequest } from 'ahooks';

/**
 * TODO: 这里要优化下实现逻辑
 */
const GlobalModel = () => {
  const { data: user, loading: userLoading, runAsync: asyncUser } = useRequest(BiGetUserInfo, { manual: true });
  const { data: menus, loading: menusLoading, run: asyncMenus } = useRequest(GetBiMenu, { manual: true });

  /** 因为没有区分作用域，用触发器来初始化全局配置 */
  const initial = () => {
    asyncUser().then((response) => {
      document.title = response.userName || '观麦采购系统';
    });
    asyncMenus();
  };

  return {
    user: user,
    menus: menus,
    /** 首个路由地址 */
    firstRoute: user?.indexUrl || '/',
    /** 全部加载完，才算loading结束 */
    loading: userLoading || menusLoading,
    initial,
  };
};

export default GlobalModel;
